/**
 * Returns true if a File is a PDF, checked by MIME type first and file
 * extension as a fallback (for cases where type is empty or unset).
 */
export function isPdfFile(file: File): boolean {
  return (
    file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf')
  );
}

/**
 * Strips the .pdf extension (case-insensitive) and trims whitespace from a
 * file's name, suitable for use as a deal or template name pre-fill.
 */
export function pdfBaseName(file: File): string {
  return file.name.replace(/\.pdf$/i, '').trim();
}
